import { makeStyles } from '@material-ui/core/styles';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PRIMARY_COLOR } from 'Config';
import React, { useState } from 'react';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        borderRadius: '3px',
        width: '100%',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const LeadGenerationIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <g>
                            <path
                                className={colorNonSelected}
                                d="M293.1,428.4c6.7,10.5,15,20.2,25.5,27c15,10.5,32.2,16.5,51.7,16.5c42,0,76.5-28.5,87-66.7
		c2.2-7.5,3-15,3-23.2c0-3,0-5.3-0.7-8.2c-3-39-31.5-70.5-67.5-79.5c-6.7-1.5-14.2-3-21.7-3c-3,0-6,0-9.7,0.7c-1.5,0-3,0-4.5,0.7
		c-43.5,6.7-76.5,44.2-76.5,89.2C280.4,399.2,284.9,414.9,293.1,428.4L293.1,428.4z M260.9,430.7c-6.7-15-10.5-31.5-10.5-48.7
		c0-54.7,36.7-100.4,86.2-115.4c3-0.7,6.7-1.5,9.7-2.2c-12-19.5-26.2-34.5-42-45.7c-7.5-6-15.7-10.5-24-13.5c-9.7-3.7-18.7-6-27.7-6
		c-7.5,0-15.7,1.5-23.2,4.5c-8.2,3-16.5,6.7-24.7,12.7c-38.2,25.5-73.5,80.2-73.5,155.2c0,6.7,0.7,12.7,3.7,18c2.2,6,6,10.5,10.5,15
		c5.2,4.5,12,9,20.2,12C189.7,426.9,225.6,432.2,260.9,430.7L260.9,430.7z M512,336.2c0,19.5-7.5,36-21,49.5c0,0,0,0.7-0.7,0.7
		c-2.2,64.5-54.7,116.2-119.9,116.2c-36,0-68.2-15.7-90-40.5c-59.2,4.5-125.9-6-155.9-36c-3-3-5.2-6-8.2-9
		c-39-2.2-75.7-12.7-95.2-32.2C7.5,371.5,0,355,0,335.5C0,295,13.5,250,36,215.5c11.2-17.2,24-30.7,38.2-41.2c2.2-2.2,3-5.2,3.7-8.2
		c0.7-4.5-0.7-9.7-3.7-13.5c-13.5-15-22.5-35.2-22.5-57.7c0-47.2,38.2-85.5,85.5-85.5c21.7,0,41.2,8.2,56.2,21.7
		c16.5-13.5,36.7-21,59.2-21c24,0,45.7,9,62.2,23.2c15-15,36-24,59.2-24c47.2,0,85.5,38.2,85.5,85.5c0,21.7-8.2,42-22.5,57.7
		c-3,4.5-3.7,9-3.7,13.5c0.7,3,1.5,6,3.7,8.2c14.2,10.5,27,24,38.2,41.2C498.5,250.8,512,295.7,512,336.2L512,336.2z M484.3,343.7
		c0.7-2.2,0.7-5.3,0.7-8.2c0-96-64.5-155.2-110.2-155.2c-14.2,0-30.7,6-46.5,16.5c13.5,10.5,26.2,24.7,36.7,41.2
		c5.3,7.5,9.7,15.7,13.5,24C428,265.8,469.3,298.7,484.3,343.7L484.3,343.7z M422,129.3c6.7-9.7,10.5-21,10.5-33.7
		c0-32.2-26.2-58.5-58.5-58.5c-16.5,0-30.7,6.7-41.2,17.2c9,15,15,32.2,15,50.2c0,13.5-3,25.5-7.5,37.5c9.7,7.5,21.7,11.2,34.5,11.2
		c16.5,0,31.5-6.7,42-18C418.3,133.8,419.8,131.6,422,129.3L422,129.3z M316.3,103.1c0-35.2-28.5-63.7-63.7-63.7
		c-35.2,0-63.7,28.5-63.7,63.7c0,35.2,28.5,63.7,63.7,63.7C287.9,166.8,316.3,138.3,316.3,103.1z M158.9,105.3
		c0-20.2,6-38.2,16.5-53.2c-10.5-9-23.2-14.2-38.2-14.2c-32.2,0-58.5,26.2-58.5,58.5c0,12.7,3.7,24,11.2,33.7
		c2.2,2.2,3.7,4.5,5.2,6.7c10.5,11.2,25.5,18,42,18c11.2,0,21.7-3,30-9C161.9,133.1,158.9,119.6,158.9,105.3L158.9,105.3z
		 M140.9,238.8c11.2-18,24.7-32.2,39.7-43.5c-14.2-9.7-30-15-43.5-15C91.5,180.3,27,239.5,27,335.5c0,12,3.7,21.7,12.7,30
		c12,11.2,36,18.7,63,21.7c-1.5-5.2-1.5-10.5-1.5-16.5C101.2,326.5,116.2,277,140.9,238.8L140.9,238.8z"
                            />
                            <path
                                className={colorSelected}
                                d="M362.1,355.7c0-6.7,3.7-11.2,10.5-11.2c6.7,0,10.5,4.5,10.5,11.2v24h24c6.7,0,11.2,3.7,11.2,10.5
		c0,6.7-4.5,10.5-11.2,10.5h-24v24c0,6.7-3.7,11.2-10.5,11.2c-6.7,0-10.5-4.5-10.5-11.2v-24h-24c-6.7,0-11.2-4.5-11.2-10.5
		c0-6.7,4.5-10.5,11.2-10.5h24V355.7z"
                            />
                        </g>
                    </svg>
                </p>
                <h6>{props.name}</h6>
                {/* <h6>Lead Generation</h6> */}
            </div>
        </>
    );
};

export default LeadGenerationIcon;
